import { axInstBasic } from "../../components/Service/Service";


export const DriverDataPie = async (payload) => {

    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getDriverDataPie`,
            payload
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching pl-filter-values data:", error);
        throw error;
    }
};


export const DriverDetails = async (payload) => {

    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getDriverDetails`,
            payload
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching pl-filter-values data:", error);
        throw error;
    }
};


export const Drivertraninggiven = async (payload) => {

    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}driver_traning_given_at`,
            payload
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching pl-filter-values data:", error);
        throw error;
    }
};
